export default __webpack_public_path__ + "static/media/arrow.18aa13bd.svg";